<template>
  <div class="title">
    <h4>{{title_name}}</h4>
  <div class=""></div>
  </div>
</template>
<script>
export default {
  // name: "title",
  props: ["title_name"],
};
</script>
<style>
  .title h4{
    text-align: center;
    background: #37c5f3;
    height: 52px;
    font-size: 2rem;
    font-weight: bold;
    border-radius: 20px 20px 0 0;
    margin: 0;
  }
</style>